









import Vue from 'vue'
import NotLogged from '@/UI/Authentication/NotLogged.vue'
import RedirectingLogin from '@/UI/Authentication/RedirectingLogin.vue'

export default Vue.extend({
  name: 'Error403',
  components: {
    NotLogged,
    RedirectingLogin
  },
  computed: {
    anchorBirds (): string {
      return require('@/UI/Assets/anchor_birds_rec.png')
    },
    anchorLine (): string {
      return require('@/UI/Assets/birds_anchor_line.png')
    },
    type (): string | null {
      const from = this.$route.params.from
      return from !== undefined && from !== '/' ? from : null
    }
  }
})
